import { defineCustomElement } from 'vue';

import 'bootstrap/js/dist/dropdown.js';
import '../scss/site.scss'
//export * from './index'

import './features/swiper';
import './features/countUp';
import './features/columns-layout';
import './features/lazyimages';
import './features/fancybox';
import './features/aosAnimations';
import './features/titleAnimation';
import './features/formValidation';
import './features/gmaps';
import './features/teamfilter';

import StickyTop from './components/StickyTop.ce.vue';
customElements.define('sticky-top', defineCustomElement(StickyTop))